import { GetBaseUrl } from '@/utils/ConfigHelper'
import axios from "axios";
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'


/**
 * @param {String} token
 * @param {{
 *      agree
 * }} data
 * @throws {Error}
 * @returns {Promise<Response>}
 */
const UpdateEmailNotificationsOption = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/user/set_email_notifications_option`;
        const config = { Authorization: `Bearer ${token}` }
        const response = await axios.post(url, data, { headers: config })
        const result = (response.status === 200);

        return new Response(result, response)
    } catch (e) {
        throw e;
    }
}

const GetAccountStatus = async (token) => {
    try {
        const url = `${GetBaseUrl()}/api/user/getaccountstatus`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)

        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 
 * @param {String} token 
 * @param {{
 *  offset?: number
 *  limit?: number
 *  provider?: string
 *  sort: number
 *  searchStr?: string
 *  onlyFinish: boolean
 * }} data 
 * @returns {Promise<Response>}
 */
const GetMyVideosNew = async (token, data = {}) => {
    try {
        const { offset, limit, provider, sort, searchStr, onlyFinish } = data
        let queryString = []
        if (offset) queryString.push(`offset=${offset}`)
        if (limit) queryString.push(`limit=${limit}`)
        if (provider) queryString.push(`provider=${provider}`)
        if (searchStr) queryString.push(`searchStr=${searchStr}`)
        queryString.push(`sort=${sort}`)
        queryString.push(`onlyFinish=${onlyFinish}`)

        const url = `${GetBaseUrl()}/api/user/videos?${queryString.join('&')}`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    UpdateEmailNotificationsOption,
    GetAccountStatus,
    GetMyVideosNew,
}